import http from "@/http-common";
import './security';

class DatagramService {
    getAllDatagrams(serverParams) {
      var data = {};
      if (serverParams) {
        data = {headers:{serverParams: JSON.stringify(serverParams)}}
      }
  
      return http.get("/debug/datagrams", data);
    }


    getDatagramDebug() {
      return http.get("/debug/datagrams/debug");
    }

    deleteAll() {  
      return http.delete("/debug/datagrams");
    }
}

export default new DatagramService();